import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('div', 'selectionWizard', ['navigatorItem']);